
const lastUpdate = '2026-03-15';
export const helpTitle = 'Weather Data Explorer';

export const helpContent = `
<h1>${helpTitle}</h1>

<h2>Overview</h2>
<p>The Weather Data Explorer provides access to unified weather observations from 2016 to present across all stations in the network.</p>

<h2>Searching and Filtering</h2>
<ul>
  <li><strong>Station ID</strong> — Search for a specific station by its identifier.</li>
  <li><strong>Date Range</strong> — Filter observations to a start and end date.</li>
  <li><strong>Region</strong> — Limit results to a specific management region.</li>
  <li><strong>Hour</strong> — Filter by observation hour (e.g., 13:00).</li>
  <li><strong>Data Source</strong> — Filter by the source of the observation data.</li>
</ul>

<h2>CFFDRS Fire Weather Indices</h2>
<p>Toggle <strong>CFFDRS</strong> to display fire weather index columns alongside standard weather data:</p>
<ul>
  <li><strong>FFMC</strong> — Fine Fuel Moisture Code</li>
  <li><strong>DMC</strong> — Duff Moisture Code</li>
  <li><strong>DC</strong> — Drought Code</li>
  <li><strong>ISI</strong> — Initial Spread Index</li>
  <li><strong>BUI</strong> — Buildup Index</li>
</ul>
<p>The <strong>FWI badge</strong> on each row shows the danger classification: <em>Low, Medium, High, Very High,</em> or <em>Extreme</em>.</p>

<h2>Exporting Data</h2>
<p>Click <strong>Export CSV</strong> to download a CSV file containing all records matching your current filters. This is useful for offline analysis or reporting.</p>

<div class="last-update">Last Updated: ${lastUpdate}</div>
`;

export default helpContent;
